<button
    type="button"
    class="ai-chat-fab btn btn-primary rounded-circle"
    [attr.aria-label]="panel.isOpen() ? 'Minimize AI Assistant' : 'Open AI Assistant'"
    [attr.aria-expanded]="panel.isOpen()"
    aria-controls="ai-chat-popup"
    (click)="panel.toggle()"
>
    <mat-icon svgIcon="smart_toy" aria-hidden="true" />
</button>

<acm-ai-chat-popup [hidden]="!panel.isOpen()" />
